import React from 'react';
import { Row, Col } from 'antd';
import { useFormContext } from 'react-hook-form';
import FormField from '../../shared/FormField';
import SelectField from '../../shared/SelectField';
import MaskedInput from '../../shared/MaskedInput';
import { CPF_MASK, CNPJ_MASK, PHONE_MASK } from '../../../utils/masks';

const TIPO_PESSOA_OPTIONS = [
  { label: 'Pessoa Física', value: 'PF' },
  { label: 'Pessoa Jurídica', value: 'PJ' },
];

const ESTADO_CIVIL_OPTIONS = [
  'Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viúvo(a)', 'União Estável',
].map((e) => ({ label: e, value: e }));

export default function ClienteInfoSection() {
  const { watch } = useFormContext();
  const tipoPessoa = watch('tipo_pessoa');

  return (
    <div className="border rounded-lg p-4 mb-4">
      <h3 className="text-lg font-semibold mb-4">Dados do Cliente</h3>

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <SelectField name="tipo_pessoa" label="Tipo de Pessoa" options={TIPO_PESSOA_OPTIONS} required />
        </Col>
        <Col xs={24} sm={16}>
          <FormField name="nome_completo" label="Nome Completo" required />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <FormField name="email_cliente" label="Email" type="email" required />
        </Col>
        <Col xs={24} sm={8}>
          <MaskedInput name="telefone" label="Telefone" mask={PHONE_MASK} required />
        </Col>
        {tipoPessoa === 'PF' && (
          <Col xs={24} sm={8}>
            <MaskedInput name="cpf" label="CPF" mask={CPF_MASK} required />
          </Col>
        )}
      </Row>

      {tipoPessoa === 'PF' && (
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <SelectField name="estado_civil" label="Estado Civil" options={ESTADO_CIVIL_OPTIONS} />
          </Col>
          <Col xs={24} sm={12}>
            <FormField name="profissao" label="Profissão" />
          </Col>
        </Row>
      )}

      {tipoPessoa === 'PJ' && (
        <>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <FormField name="razao_social" label="Razão Social" required />
            </Col>
            <Col xs={24} sm={12}>
              <MaskedInput name="cnpj" label="CNPJ" mask={CNPJ_MASK} required />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <FormField name="finalidade_empresa" label="Finalidade da Empresa" />
            </Col>
            <Col xs={24} sm={12}>
              <FormField name="cargo_representante" label="Cargo do Representante" />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}
